import { api } from "../axios";
import { DistributorBranding } from "../../types";

export function getDistributorBranding(): Promise<DistributorBranding> {
  return api.get("distributor/branding/");
}

export function updateDistributorBranding(
  branding: FormData
): Promise<DistributorBranding> {
  return api.put("distributor/branding/", branding, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
